<template>
    <div class="order">
        <orderMsg v-if="to_order_way == 1" :orderData="this.orderMsgData" :theWayTo="to_order_way"></orderMsg>
        <orderMsg v-else v-for="(item,index) in orderMsgDataArr" :key="index" :orderData="item"
                  :theWayTo="to_order_way"></orderMsg>
        <div class="buyerMsg">
            <h1>购买人信息</h1>
            <div class="buyerTable">
                <div class="input">
                    <label>姓名</label>
                    <input type="text" placeholder="请填写姓名" v-model="buyerName">
                </div>
                <div class="input">
                    <label>手机号码</label>
                    <input type="text" placeholder="请填写手机号码" v-model="buyerTel">
                </div>
                <!-- <div class="input" v-if="to_order_way == 0 || singleGoodsCatId == 859">
                    <label>身份证号</label>
                    <input type="text" placeholder="请填写身份证号码" v-model="buyerIdCard">
                </div> -->
                <div class="input">
                    <span>邮箱地址</span>
                    <input type="text" placeholder="请填写邮箱地址" v-model="buyerE_mail">
                </div>
                <div class="input">
                    <span>优惠券</span>
                    <div id="select">
                        <select v-model="coupon_id">
                            <option value="">-----请选择优惠卷-----</option>
                            <!-- <option value="1">10</option>
                            <option value="2">15</option>
                            <option value="3">20</option>
                            <option value="4">50</option>
                            <option value="5">100</option> -->
                            <option v-for="(c,index) in couponsArr" :value="c.coupon_id" :key="index">{{c.name}}
                            </option>
                        </select>
                        <!--<img src="../../assets/images/xuebi_13.png" alt="" class="selImg">-->
                    </div>


                </div>
            </div>
            <div class="buyer_price">
                <p><span class="buyer_price_l" id="all_price">订单总额</span> <span class="buyer_price_r">￥{{orderTotalMoney}}</span>
                </p>
                <p><span class="buyer_price_l" id="discount">优惠券</span> <span
                        class="buyer_price_r">￥{{discountsMoney}}</span></p>
                <p><span class="buyer_price_l" id="payment">支付金额</span> <span
                        class="buyer_price_r">￥{{orderPayMoney}}</span></p>
            </div>
            <div class="book_notice">
                <p class="book_notice_content">
                    <input type="checkbox" v-model="isRead"><span>我已经阅读 <b @click="showBookingKnow()">《预定须知》</b></span>
                </p>
            </div>
            <div class="msg_btn" @click="submit()">提交订单</div>

        </div>
        <!-- <mt-popup v-model="popupVisible" position="left" class="readPopup" v-html="bookingKnowContent"></mt-popup> -->
        <div class="bookingKnowLayerContainer" v-if="isShowBookingKnow" @click="hideBookingKnow()"></div>
        <div class="layerCore" v-if="isShowBookingKnow">
            <!--<h1>预定须知</h1>-->
            <div class="layerContent" ref="layerContent" v-html="bookingKnowContent"></div>

            <span @click="hideBookingKnow()">已阅读</span>
        </div>
    </div>
</template>

<script>
    import orderMsg from "../../components/markets/orderMsg";
    // import {getContent} from "../../assets/js/information";

    export default {
        name: "order",
        components: {
            orderMsg
        },
        inject: ["showMsg"],
        data() {
            return {
                lastY: 0,
                isRead: false,
                couponsArr: [],
                isShowBookingKnow: false,
                orderMsgData: "",
                orderMsgDataArr: "",
                // singleGoodsCatId:this.$route.query.cat_id_2,
                buyerName: "",
                buyerTel: "",
                buyerIdCard: "",
                buyerE_mail: "",
                regName: /^[\u4e00-\u9fa5a-zA-Z]+$/, //姓名的正则表达式
                regTel: /^1[34578]\d{9}$/, //手机号的正则表达式
                regIdCard: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/, //身份证号的正则表达式
                orderTotalMoney: "", //订单总金额
                orderPayMoney: "", //订单的支付金额
                discountsMoney: "0.00", //优惠金额(默认0.00元)
                discountsMoneyNum: 0, //优惠金额,数值0(默认0元)
                popupVisible: false,
                coupon_id: "", //优惠卷id
                to_order_way: this.$route.query.to_order_way, //进入的方法，1为单品，0为从购物车进入
                /*bookingKnowContent:
                  '<div style="padding: 10px 15px; line-height: 24px; background-color: #fcf6ef; color: #282828; font-weight: 300;">' +
                  '<h3 style="line-height: 28px">一、【门票说明】</h3>\n' +
                  "1、预订门票须至少提前一天下单支付成功方可生效，逾期不可预订。<br>\n" +
                  "2、当天票须至少在出游当天14:00前下单支付成功方可生效，逾期不可预订。<br>\n" +
                  "3、在线订票只有在线支付可以享受优惠政策，只预订不支付者不享受任何折扣待遇。<br>\n" +
                  "4、在线订票不再享受景区现金卡或者园区促销活动等的优惠。<br>\n" +
                  "5、在线预订儿童或老人票的游客，如儿童身高超过标准或长者游客入园时未能出示有效的身份证明文件，游客须按入园门市价补回差额。<br>\n" +
                  "6、网络购票取票地址：长鹿旅游休博园网络售票窗口。<br>\n" +
                  "7、取票凭证：凭证码。<br>\n" +
                  "8、相关优惠门票请在门票到期后3天内申请退款，逾期不候。<br>\n" +
                  "9、半票适用范围：<br>\n" +
                  "① 60-69岁的长者（凭有效身份证件）；<br>\n" +
                  "② 年龄在3周岁（含）至12周岁（不含）或身高1米（含）至1.5米（不含）的儿童；<br>\n" +
                  "③ 三级伤残人士（凭有效证件）。<br>\n" +
                  "10、免票适用范围：<br>\n" +
                  "① 70岁以上长者（凭有效身份证件）；<br>\n" +
                  "② 年龄在3周岁（不含）以下或身高1米（不含）以下的儿童；<br>\n" +
                  "③ 一、二级伤残人士（凭有效证件）。<br>\n" +
                  "11、全票适用范围：<br>\n" +
                  "① 成人及身高1.5米以上人群；<br>\n" +
                  "② 60岁以下人群。<br>\n" +
                  "12、地球村表演半票适用范围：<br>\n" +
                  "① 1.0（含）-1.5（不含）米,年龄在3周岁（含）至12周岁（不含）的儿童及60岁以上长者（凭有效身份证件）须到游客服务中心购买半票进园观看；<br>\n" +
                  "② 成人及1.5米以上儿童须购买全票进园。<br>\n" +
                  "13、餐饮代金券范围：按指定餐饮券说明使用。<br>\n" +
                  '<h3 style="line-height: 28px">二、【酒店说明】</h3>\n' +
                  "1、预订成功后，需要工作人员进行二次房间确认方可出行，出游当天可凭预订姓名与手机号码到度假酒店门口领取大门票，核实信息后可到酒店前台办理入住手续并领取门票。<br> \n" +
                  "2、酒店平日入住时间为14:00，周六日、大型节假日及寒暑假期间入住时间为15:00，如提前到店，可先到酒店前台办理手续并领取门票入园游玩，流程：入住登记-换取/购买门票并寄存行李-入园游玩；退房时间为次日中午12:00前。 <br>\n" +
                  "3、预订客人的姓名必须和入住客人的姓名一致，所有入住人均须提供有效身份证办理（人手一证），儿童若未办理身份证，可携带户口本或出生证复印件。<br> \n" +
                  "4、18周岁以下青年或儿童须在成人陪同下方可入住。<br>\n" +
                  "5、酒店产品套餐包含的游乐金可用于游玩园区的机动游乐项目、喂食动物、观看海陆空动物表演、木偶剧表演或童话动物剧场、夹公仔等，入园后可多人共用；游乐金不够用可于园区充值点充值，最低现金充值30元，享受充一送一的优惠，即充30元有60元游乐金，游乐金用不完不可退款或折现。<br>\n" +
                  "6、酒店地址：佛山市顺德区伦教三洲建设东路8号，酒店24小时服务热线：0757-27331111。<br> \n" +
                  "7、度假酒店湖心岛的室外泳池、温泉、SPA、山洞蒸汽浴、矿洞主题海洋馆等项目已全新开放。<br>\n" +
                  "8、营业时间：①度假村：24小时营业；②园区：周一至周五09:30-18:00、周六 09:30-19:00、周日 09:30-18:30、黄金周以当日公告时间为准。<br> \n" +
                  '<h3 style="line-height: 28px">三、【预订规则】</h3>\n' +
                  "1、酒店所有客房预订一经确认后，如有行程变动，请至少提前一天致电预订部0757-27331641办理退改手续，因酒店客房具有时效性，若入住当天取消，需收取50%的违约金。酒店承诺保留房间至客人到店当天。若客人不按时入住，房间也不会无故转让给其他客人，因此而导致的酒店房间空置，所有客人预订的费用照常收取，不予退还。请您认真阅读酒店产品详情后谨慎下订单。<br>\n" +
                  "2、预订酒店类产品，需提供真实有效的入住人姓名和有效的手机号码。若因预留的入住信息错误或不全，和联络信息不准确，不能提前与您确认入住的准确信息，因而造成客人无法入住及损失等情形时，本店及酒店不接受退款且一律免责。<br>\n" +
                  "3、预订成功后如遇酒店推出其它优惠促销，恕不另行通知，也不能同时享受该优惠。<br> \n" +
                  "4、酒店产品内容及有效期等如有变动，以长鹿旅游休博园旗舰店最新公布信息为准，恕不另行通知。<br>\n" +
                  "5、根据国家法规规定，为确保您的权益及游程顺利，请随身携带并自行保管好您的有效身份证件，办理入住须出示所有入住人身份证件。<br>\n" +
                  "6、若有超出酒店产品限定人数的同行者，则须另外购买长鹿旅游休博园门票方可入园，购票标准：成人及身高1.5米（含）以上儿童或者年龄12岁（含）以上须购买成人票，身高1.0米（含）-1.5米（不含）年龄3-12（不含）的儿童及60-69岁长者可购买儿童票/老人票，1.0米以下或者3岁以下儿童及70岁（含）以上长者可免票入园门票及动物园门票，门票可在酒店前台办理延期，住店期间均可使用。<br>  \n" +
                  '<h3 style="line-height: 28px">四、【优惠政策】</h3> \n' +
                  "1、优惠门票、酒店、餐饮、年卡等产品包括以上单并不仅限于以上产品，在进行优惠促销活动时的条件规则，以活动优惠最新规则为准；<br>\n" +
                  "2、如因活动规则未写明造成游客的损失应由休博园承担；如已注明清楚优惠规则游客未仔细查看造成的损失应由游客全部承担；<br>\n" +
                  "3、休博园会不定期推出优惠活动，优惠活动抢购的门票、酒店、餐饮等按照指定规则退改或者预约，不可无操作，请在有效期内出行使用；<br>\n" +
                  "4、抢购门票、酒店、餐饮等产品需要进行二次预约，请关注官方微信公众号“长鹿旅游休博园”进行二次预约，门票、酒店、餐饮至少提前一天预约，预约成功后不退不改。<br>\n" +
                  '<h3 style="line-height: 28px">五、【关于发票】</h3> \n' +
                  "发票由长鹿度假酒店、长鹿前台、长鹿网络客服开具，请客人在离店日到酒店前台、客服处办理；如离店后需补开发票，请在消费后15天内联系客服办理，可补发电子发票或纸质发票，补发纸质发票将快递寄出，邮费由阁下承担。<br>\n" +
                  "● 如需退票请联系客服：0757-27331088/27331641<br>\n" +
                  "● 请勿携带易燃易爆物品、宠物、食品、酒水有色饮品进园 (婴儿食物除外)；<br>\n" +
                  "● 相关服务的最终解释权归长鹿旅游休博园所有。<br>\n</div>"*/
                bookingKnowContent: ""
            };
        },
        created: function () {
            this.$store.commit("set_current", 6);
            this.$store.commit("set_title", "order");
            // 根据进入确认订单页面的途径不同，该页面所显示的数据也不同
            if (this.to_order_way == 1) {
                //单件商品进入
                // console.log("二");
                // 整合本次订单的相关数据，传递给子组件
                let goodsOrderInfoStr = localStorage.getItem("goodsOrderInfo");
                let totalPrices = localStorage.getItem("totalPrices");
                let goodsOrderInfo = JSON.parse(goodsOrderInfoStr);
                goodsOrderInfo.chooseDate = localStorage.getItem("chooseDate");
                goodsOrderInfo.chooseToDate = localStorage.getItem("chooseToDate");
                this.orderMsgData = goodsOrderInfo;
                this.getDiscounts(this.orderMsgData);
                // 计算订单总金额
                let a = parseFloat(goodsOrderInfo.shop_price); //单价
                let b = parseInt(goodsOrderInfo.goods_num); //数量
                let c = a * b; //总价
                let d = c.toFixed(2); //保留两位小数
                this.orderTotalMoney = totalPrices;
                // 支付金额（在没有使用优惠卷的情况下，订单总金额==支付金额）
                this.orderPayMoney = totalPrices;
            } else {
                //购物车商品进入
                // 整合本次订单的相关数据，传递给子组件
                let buyCarOrderInfoStr = localStorage.getItem("buyCarOrderInfo");
                let cartPriceInfoStr = localStorage.getItem("cartPriceInfo");
                let buyCarOrderInfo = JSON.parse(buyCarOrderInfoStr);
                let cartPriceInfo = JSON.parse(cartPriceInfoStr);
                // console.log(buyCarOrderInfo);
                // console.log(cartPriceInfo);
                // console.log("三");
                this.orderMsgDataArr = buyCarOrderInfo;
                this.orderTotalMoney = cartPriceInfo.total_fee.toFixed(2);
                // 支付金额（在没有使用优惠卷的情况下，订单总金额==支付金额）
                this.orderPayMoney = cartPriceInfo.total_fee.toFixed(2);
            }
        },
        computed: {
            weburl: function () {
                return this.$store.state.weburl;
            },
            hurl: function () {
                return this.$store.state.hurl;
            }
        },
        methods: {
            // 获取用户的优惠卷的方法
            getDiscounts: function (orderMsgData) {
                console.log(orderMsgData);
                // 在这里要把用户选择的购买日期格式给修改成
                let buyGoodsDateStr = orderMsgData.chooseDate;
                let buyGoodsDateArr = buyGoodsDateStr.split("-");
                let buyGoodsDateYear = buyGoodsDateArr[0];
                let buyGoodsDateMonth = buyGoodsDateArr[1];
                let buyGoodsDateDay = buyGoodsDateArr[2];

                let buyGoodsToDateStr = orderMsgData.chooseToDate;

                let buyGoodsToDateArr = buyGoodsToDateStr.split("-");
                let buyGoodsToDateYear = buyGoodsToDateArr[0];
                let buyGoodsToDateMonth = buyGoodsToDateArr[1];
                let buyGoodsToDateDay = buyGoodsToDateArr[2];
                this.$http({
                    xhrFields: {
                        withCredentials: true
                    },
                    crossDomain: true,
                    method: "post",
                    url: this.weburl + this.hurl + "/Cart/checkCoupons",
                    dataType: "json",
                    data: {
                        goods_id: orderMsgData.goods_id,
                        goods_num: orderMsgData.goods_num,
                        action: "buy_now",
                        year: buyGoodsDateYear,
                        month: buyGoodsDateMonth,
                        day: buyGoodsDateDay,
                        toyear: buyGoodsToDateYear,
                        tomonth: buyGoodsToDateMonth,
                        today: buyGoodsToDateDay
                    }
                })
                    .then(res => {
                        if (res.data.status === 1) {
                            if (!res.data.result || res.data.result.length === 0) {
                                return false;
                            }
                            this.couponsArr = res.data.result;
                        }
                    })
                    .catch(err => {
                        this.showMsg("网络错误，请稍后再试");
                        console.log(err);
                    });
            },
            // 用户点击“提交订单”的方法
            submit: function () {
                // console.log(this.isRead);
                if (this.buyerName) {
                    if (!this.regName.test(this.buyerName)) {
                        this.showMsg("姓名格式错误");
                        return false;
                    }
                } else {
                    this.showMsg("姓名不能为空");
                    return false;
                }

                if (this.buyerTel) {
                    if (!this.regTel.test(this.buyerTel)) {
                        this.showMsg("手机号格式错误");
                        return false;
                    }
                } else {
                    this.showMsg("手机号不能为空");
                    return false;
                }

                if (!this.isRead) {
                    this.showMsg("请先阅读《预定须知》");
                    return false;
                }
                if (this.to_order_way) {
                    // 整理需要向服务器发送的数据
                    let postData = {};
                    postData.coupon_id = this.coupon_id;
                    postData.goods_id = this.orderMsgData.goods_id;
                    postData.goods_num = this.orderMsgData.goods_num;
                    postData.year = this.formatChooseDate(this.orderMsgData.chooseDate)[0];
                    postData.month = this.formatChooseDate(this.orderMsgData.chooseDate)[1];
                    postData.day = this.formatChooseDate(this.orderMsgData.chooseDate)[2];
                    postData.toyear = this.formatChooseDate(this.orderMsgData.chooseToDate)[0];
                    postData.tomonth = this.formatChooseDate(this.orderMsgData.chooseToDate)[1];
                    postData.today = this.formatChooseDate(this.orderMsgData.chooseToDate)[2];
                    postData.linkName = this.buyerName;
                    postData.mobile = this.buyerTel;
                    postData.action = "buy_now";
                    postData.act = "submit_order";
                    // if(this.singleGoodsCatId == 859){
                    //     if(this.buyerIdCard){
                    //         if(!this.regIdCard.test(this.buyerIdCard)){
                    //             this.showMsg("身份证号格式错误");
                    //             return false;
                    //         }
                    //     }else{
                    //         this.showMsg("身份证号不能为空");
                    //         return false;
                    //     }
                    //     postData.certificateNo = this.buyerIdCard;
                    // }
                    // 发送请求
                    this.$http({
                        xhrFields: {
                            withCredentials: true
                        },
                        crossDomain: true,
                        method: "post",
                        url: this.weburl + this.hurl + "/Cart/checkOrder",
                        dataType: "json",
                        data: postData
                    })
                        .then(res => {
                            if (res.data.status === 1) {
                                // 把购买者的手机号存入localStorage中，为支付成功后发短信显示做准备
                                localStorage.setItem(
                                    "userMobileNum",
                                    JSON.stringify(this.buyerTel)
                                );
                                this.$router.push({
                                    path: "/orderPayChoose",
                                    query: {
                                        order_sn: res.data.result.order_sn,
                                        order_id: res.data.result.order_id
                                    }
                                });
                            } else {
                                this.showMsg(res.data.msg);
                            }
                        })
                        .catch(err => {
                            this.showMsg("网络错误，请稍后再试");
                            console.log(err);
                        });
                } else {
                    // if(this.buyerIdCard){
                    //     if(!this.regIdCard.test(this.buyerIdCard)){
                    //         this.showMsg("身份证号格式错误");
                    //         return false;
                    //     }
                    // }else{
                    //     this.showMsg("身份证号不能为空");
                    //     return false;
                    // }

                    // 整理需要向服务器发送的数据
                    let postData = {};
                    postData.coupon_id = this.coupon_id;
                    postData.linkName = this.buyerName;
                    postData.mobile = this.buyerTel;
                    // postData.certificateNo = this.buyerIdCard;
                    postData.act = "submit_order";
                    this.$http({
                        method: "post",
                        url: this.weburl + this.hurl + "/Cart/checkOrders",
                        dataType: "json",
                        data: postData
                    })
                        .then(res => {
                            if (res.data.status === 1) {
                                this.$router.push({
                                    path: "/orderPayChoose",
                                    query: {
                                        order_sn: res.data.result.order_sn,
                                        order_id: res.data.result.order_id,
                                        order_type: this.$route.query.cat_id_2
                                    }
                                });
                            } else {
                                this.showMsg(res.data.msg);
                            }
                        })
                        .catch(()=> {
                            this.showMsg("网络错误，请稍后再试");
                        });
                }
            },
            showBookingKnow: function () {
                // this.popupVisible = true;
                this.$http({
                    url:this.weburl +"/home/Other/getAttention",
                    dataType: 'json',
                    method:'post',
                    data:{
                        lang: window.$lang
                    },
                })
                    .then(res =>{
                    console.log(res);
                    if( res.data.status ===1 ){
                        this.bookingKnowContent = this.htmlDecode(res.data.result.content);
                    }else {
                        this.showMsg(res.data.msg);
                    }
                })
                    .catch(()=>{
                    this.showMsg("网络错误，请稍后再试");
                });
                this.isShowBookingKnow = true;
            },
            hideBookingKnow: function () {
                this.isShowBookingKnow = false;
            },
            // 将用户所选择的购买时间chooseDate分割成一个数组
            formatChooseDate: function (dateStr) {
                return dateStr.split("-");

            }
        },
        mounted: function () {
            document.body.addEventListener(
                "touchstart",
                e => {
                    this.lastY = e.changedTouches[0].clientY;
                },
                false
            );
            // console.log(document.body);
            // console.log(this.$refs.layerContent);

            // this.$refs.layerContent.addEventListener("touchmove",(e) =>{
            //     e.stopPropagation();  //阻止事件冒泡
            //     let scrollTop = this.$refs.layerContent.scrollTop;
            //     let clientHeight = this.$refs.layerContent.clientHeight;
            //     let scrollHeight = this.$refs.layerContent.scrollHeight;
            //     let clientY = e.changedTouches[0].clientY;
            //     if(scrollTop == 0){
            //         if(clientY > this.lastY){
            //             e.preventDefault();
            //             console.log("top");
            //         }
            //     }
            //     if((scrollTop + clientHeight) == scrollHeight){
            //         if(clientY < this.lastY){
            //             e.preventDefault();
            //             console.log("bottom");
            //         }
            //     }
            // },false)
        },
        watch: {
            coupon_id: function (n, o) {
                console.log(n);
                if (!n) {
                    return false;
                }
                for (var i = 0; i < this.couponsArr.length; i++) {
                    if (this.couponsArr[i].coupon_id == n) {
                        this.discountsMoney = this.couponsArr[i].money;
                        this.discountsMoneyNum = parseFloat(this.couponsArr[i].money);
                    }
                }
                let a = parseFloat(this.orderPayMoney);
                let b = a - this.discountsMoneyNum;
                this.orderPayMoney = b.toFixed(2);
            },
            isShowBookingKnow: function (n, o) {
                // console.log(n);
                if (n) {
                    setTimeout(() => {
                        this.$refs.layerContent.addEventListener(
                            "touchmove",
                            e => {
                                e.stopPropagation(); //阻止事件冒泡
                                let scrollTop = this.$refs.layerContent.scrollTop;
                                let clientHeight = this.$refs.layerContent.clientHeight;
                                let scrollHeight = this.$refs.layerContent.scrollHeight;
                                let clientY = e.changedTouches[0].clientY;
                                if (scrollTop == 0) {
                                    if (clientY > this.lastY) {
                                        e.preventDefault();
                                        console.log("top");
                                    }
                                }
                                if (scrollTop + clientHeight == scrollHeight) {
                                    if (clientY < this.lastY) {
                                        e.preventDefault();
                                        console.log("bottom");
                                    }
                                }
                            },
                            false
                        );
                    }, 1000);
                }
            }
        }
    };
</script>

<style scoped type="text/css" lang="less">
    @import "../../assets/less/common.less";

    .buyerMsg h1 {
        height: 54px;
        line-height: 54px;
        .border-bottom;
        padding-left: 20px;
        color: @brick_red;
        font-size: @font;
    }

    .buyerTable,
    .buyer_price,
    .book_notice {
        .box-sizing;
        width: @width;
        padding: 0 10px 10px 20px;
        .border-bottom(5px, #e0e0e0);
    }

    .input {
        width: 100%;
        height: 59px;
        line-height: 59px;
        label,
        span {
            width: 20%;
            display: inline-block;
            font-size: 0.9rem;
            position: relative;
        }
        input {
            width: 80%;
            height: calc(90% - 1px);
            .border-bottom(1px, #e0e0e0);
            font-size: 0.9rem;
        }
        label:before {
            position: absolute;
            content: "*";
            color: #8b3c3f;
            font-size: 0.9rem;
            left: -8px;
        }
        #select {
            width: 80%;
            height: calc(100% - 1px);
            .border-bottom(1px, #e0e0e0);
            font-size: 0.9rem;
            position: relative;
            display: inline-block;
            select {
                width: @width;
                height: 92%;
                appearance: none;
                -webkit-appearance: none;
                -moz-appearance: none;
            }
            &:after {
                content: "";
                right: 0;
                top: -3%;
                background: url("@{sprite}") no-repeat -281px 0px;
                width: 31px;
                height: 48px;
                background-size: 315px auto;
                pointer-events: none;
            }
        }
    }

    ::-webkit-input-placeholder {
        color: #e1e1e1;
    }

    :-ms-input-placeholder {
        color: #e1e1e1;
    }

    ::-moz-placeholder {
        color: #e1e1e1;
        opacity: 1;
    }

    .buyer_price p {
        line-height: 45px;
        height: 45px;
    }

    .buyer_price_r {
        float: right;
        color: #e12033;
    }

    .book_notice_content {
        height: 45px;
        line-height: 55px;
        position: relative;
        overflow: hidden;
        margin-bottom: 0.5rem;
        // &:after, &:before {
        //     content: '';
        //     top: 12px;
        //     // background:  url("@{sprite}")  no-repeat;
        //     height: 28px;
        //     background-size: 238px auto;
        // }
        &:after {
            width: 17px;
            right: 6px;
            background-position: -55px -7px;
        }
        &:before {
            left: 0;
            width: 31px;
            background-position: -24px -7px;
        }
        span {
            display: inline-block;
            // margin-left: 33px;
            margin-left: 7px;
            b {
                color: #5180f2;
            }
        }
    }

    .msg_btn {
        width: 80%;
        .border-radius(10px);
        background: @brick_red;
        color: #fff;
        text-align: center;
        line-height: 50px;
        height: 50px;
        font-size: @font + 0.1;
        margin: @font auto @font * 2;
    }

    .readPopup {
        width: 100%;
        height: 50%;
    }

    .bookingKnowLayerContainer {
        width: 100vw;
        height: 100vh;
        background-color: gray;
        opacity: 0.5;
        position: fixed;
        z-index: 101;
        top: 0;
        left: 0;
    }

    .layerCore {
        width: 80%;
        height: 60%;
        position: fixed;
        top: 15%;
        left: 10%;
        background-color: white;
        z-index: 102;
        border-radius: 15px;
        // text-align: center;
        // overflow-y: scroll;
        // overflow-y:visible;
        // overflow-y:hidden;
    }

    .layerCore h1 {
        font-size: 1.5rem;
        text-align: center;
        margin-top: 10px;
        margin-bottom: 10px;
        font-weight: 550;
        color: #732727;
    }

    .layerContent {
        padding: 20px;
        height: 74%;
        overflow-y: scroll;
    }

    .layerCore span {
        display: inline-block;
        background-color: #732727;
        color: white;
        font-size: 1.1rem;
        letter-spacing: 1px;
        width: 26%;
        height: 2rem;
        line-height: 2rem;
        text-align: center;
        border-radius: 5px;
        position: relative;
        left: 37%;
        top: 20px;
    }
</style>
